import { render, staticRenderFns } from "./personalKesehatan.vue?vue&type=template&id=029ba8e6&"
import script from "./personalKesehatan.vue?vue&type=script&lang=ts&"
export * from "./personalKesehatan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports